import { authApi } from "../interceptor/auth.interceptor";

class TikTokService {
  static async TikTokCode(queryParams) {
    return await authApi.post(`tiktok/code?${queryParams}`).then((response) => {
      return response?.data;
    });
  }
}

export default TikTokService;
